import { Component, inject, OnInit } from "@angular/core"
import { ProgramDTO, ProgramService } from "@services/program.service"
import { ButtonModule } from "primeng/button"
import { RouterLink } from "@angular/router"
import { ProgramPubDTO, ProgramPublishedService } from "@services/program.published.service"
import { ConfirmationService } from "primeng/api"
import { NotifService } from "@services/notif.service"
import { Utils } from "@services/utils"
import { DropdownModule } from "primeng/dropdown"
import { FormsModule } from "@angular/forms"
import { CalendarModule } from "primeng/calendar"
import { DialogModule } from "primeng/dialog"
import { Editor2Component } from "@components/editor2/editor2.component"

@Component({
  selector: "app-admin-home",
  standalone: true,
  imports: [ButtonModule, RouterLink, DropdownModule, FormsModule, CalendarModule, DialogModule, Editor2Component],
  templateUrl: "./admin-home.component.html",
  styleUrl: "./admin-home.component.scss",
})
export class AdminHomeComponent implements OnInit {
  confirmService = inject(ConfirmationService)
  programService = inject(ProgramService)
  programPubService = inject(ProgramPublishedService)
  notifService = inject(NotifService)

  showCreate = true
  programs: Array<ProgramDTO> = []
  programsOptions: Array<any> = []
  // currentProgram?: ProgramPubDTO

  popupProgramId: string | null = null
  popupTimeStart: Date | undefined
  popupTimeEnd: Date | undefined
  popupCurrentProgram = false

  currentProgramInfoTxt = ""
  currentProgramTimeTxt = ""
  currentProgramInfo: any = {}
  programOnAir = false

  async ngOnInit() {
    this.programs = await this.programService.getAllFromCache()
    this.programs.sort(
      (a, b) => Utils.extractDateIntegerFromString(b.date) - Utils.extractDateIntegerFromString(a.date)
    )
    this.programsOptions = this.programs.map((p) => ({ id: p.id || "", label: `${p.date} - ${p.town} - ${p.name}` }))
    await this.updateCurrentProgramInfo()
  }

  debug(event: any) {
    if (event.ctrlKey) {
      this.showCreate = true
    }
  }

  async updateCurrentProgramInfo() {
    this.currentProgramInfo = await this.programPubService.getCurrentProgramInfo()
    const program = this.programs.find((p) => p.id === this.currentProgramInfo?.id)
    this.currentProgramInfoTxt = "Aucun"
    this.currentProgramTimeTxt = ""
    this.programOnAir = false
    if (program) {
      this.programOnAir = this.programPubService.isProgramInfoOnAir(this.currentProgramInfo)
      this.currentProgramInfoTxt = `${program.name} ~ ${program.date} ~ ${program.town}`
      this.currentProgramTimeTxt = `${this.currentProgramInfo.date_start?.toLocaleString(
        "fr-FR"
      )} - ${this.currentProgramInfo.date_end?.toLocaleString("fr-FR")}`
    }
  }

  onCurrentProgramChange() {
    const program = this.programs.find((p) => p.id === this.popupProgramId)
    const date = Utils.extractDateFromString(program?.date || "")
    this.popupTimeStart = new Date(date.year, date.month - 1, date.day)
    const endDate = new Date(date.year, date.month - 1, date.day)
    endDate.setHours(23)
    this.popupTimeEnd = endDate
  }

  async saveCurrentProgram() {
    const program = this.programs.find((p) => p.id === this.popupProgramId)
    if (program) {
      await this.setCurrentProgram(program, this.popupTimeStart, this.popupTimeEnd)
      this.notifService.displaySuccess("Le programme courant a été mise à jour")
      this.popupCurrentProgram = false
    }
  }

  showPopupCurrentProgram() {
    this.popupCurrentProgram = true
    this.popupProgramId = this.currentProgramInfo?.id || ""
    this.popupTimeStart = this.currentProgramInfo?.id || ""
    this.popupTimeStart = this.currentProgramInfo?.date_start
    this.popupTimeEnd = this.currentProgramInfo?.date_end
    // this.currentProgramId = this.
  }

  async setCurrentProgram(program: ProgramDTO, startDate: Date | undefined, endDate: Date | undefined): Promise<void> {
    const pub = await this.programPubService.get(program?.id || "")
    if (pub && pub.date_published) {
      await this.programPubService.saveCurrentProgram(program.id || "", startDate, endDate)
      await this.updateCurrentProgramInfo()
    }
  }

  async duplicate(program: ProgramDTO) {
    this.confirmService.confirm({
      message: `Le programme <b>"${program.name} ~ ${program.date} ~ ${program.town}"</b> sera dupliqué <br>Souhaitez-vous continuer?`,
      header: "Duplication de programme",
      icon: "pi",
      acceptLabel: "Confirmer",
      rejectLabel: "Annuler",
      accept: async () => {
        await this.programService.duplicateProgram(program?.id || "", "Duplication---" + program.name)
        this.programs = await this.programService.getAllFromCache()
        this.programs.sort(
          (a, b) => Utils.extractDateIntegerFromString(b.date) - Utils.extractDateIntegerFromString(a.date)
        )
      },
      reject: () => {},
    })
  }
}
